import { CustomSelectFieldProps } from 'components/form'
import { SelectFieldWithAddButton } from 'components/form/core/SelectField/SelectFieldWithAddButton'
import { useAtestadoModelosLoadQuery } from 'graphql/hooks.generated'
import { useEffect, useState } from 'react'

import AtestadoModeloModal from '../modelo/AtestadoModeloModal'
import { filterModelosAtestadoPermitidos } from '../utils-atestado'
import { AtestadoModeloEnum, AtestadoSelectModel, atestadoSelectModelDefaultRecord } from './model-atestado'

type AtestadoSelectFieldProps = CustomSelectFieldProps<AtestadoSelectModel> & {
  canAccessLicencaMaternidade: boolean
  canAccessFraldasGeriatricas: boolean
  needRefetch: boolean
  onRefetch(): void
}

const atestadosDefault = Object.values(atestadoSelectModelDefaultRecord)

export function AtestadoSelectField(props: AtestadoSelectFieldProps) {
  const { canAccessLicencaMaternidade, canAccessFraldasGeriatricas, needRefetch, onRefetch, ...rest } = props
  const [isModeloOpen, setModeloOpen] = useState(false)
  const { data, refetch } = useAtestadoModelosLoadQuery({ fetchPolicy: 'cache-first' })

  useEffect(() => {
    if (needRefetch) {
      refetch()
      onRefetch()
    }
  }, [refetch, onRefetch, needRefetch])

  const extractItems = () => {
    const modelosCustom = data?.atestadoModelos
      ?.map((modelo) => ({ ...modelo, tipo: AtestadoModeloEnum.PERSONALIZADO } as AtestadoSelectModel))
      .sort((a, b) => a.nome.localeCompare(b.nome))

    const modelosDefault = filterModelosAtestadoPermitidos(atestadosDefault, {
      [AtestadoModeloEnum.LICENCA_MATERNIDADE]: canAccessLicencaMaternidade,
      [AtestadoModeloEnum.SOLICITACAO_FRALDAS_GERIATRICAS]: canAccessFraldasGeriatricas,
    })

    return modelosCustom ? modelosDefault.concat(modelosCustom) : modelosDefault
  }

  const itemToString = (item: AtestadoSelectModel) => item?.nome

  return (
    <>
      <SelectFieldWithAddButton<AtestadoSelectModel>
        items={extractItems()}
        itemToString={itemToString}
        clearable={false}
        defaultValue={atestadoSelectModelDefaultRecord[AtestadoModeloEnum.PADRAO] as any}
        addText={undefined}
        addButtonText='Cadastrar modelo'
        onClickAddButton={() => setModeloOpen(true)}
        {...rest}
      />
      {isModeloOpen && <AtestadoModeloModal onClose={() => setModeloOpen(false)} onUpdate={() => refetch()} />}
    </>
  )
}
